import React from 'react'
import { connect } from 'react-redux'
import { logoff } from '../ducks/Auth'
import * as Ps from 'perfect-scrollbar'
import { resetForm, submitForm } from '../ducks/Forms'
import 'perfect-scrollbar/dist/css/perfect-scrollbar.min.css'
import Sidebar from 'components/Sidebar/Sidebar.jsx'
import Header from 'components/Header/Header.jsx'
import NotificationSystem from 'react-notification-system'
import { style as NotifyStyle } from '../variables/Variables.jsx'
import { Switch, Route, Redirect, withRouter } from 'react-router-dom'

import eneleRoutes from '../routes/enele.jsx'

class Enele extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            _notificationSystem: null
        }
    }

    isMac() {
        let bool = false
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true
        }
        return bool
    }
    componentDidUpdate(e) {
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            setTimeout(() => { Ps.update(this.refs.mainPanel) }, 350)
        }
        if (e.history.action === "PUSH") {
            this.refs.mainPanel.scrollTop = 0
        }
    }
    componentWillMount() {
        if (document.documentElement.className.indexOf('nav-open') !== -1) {
            document.documentElement.classList.toggle('nav-open')
        }
    }

    componentDidMount() {
        this.setState({ _notificationSystem: this.refs.notificationSystem })
    }

    render() {
        const { user, resetForm, submitForm } = this.props

        return (
            <div className="wrapper">
                <NotificationSystem ref="notificationSystem" style={NotifyStyle} />
                <Sidebar {...this.props} />
                <div className="main-panel" ref="mainPanel">
                    <Header {...this.props} />
                    <Switch>
                        {
                            eneleRoutes.map((route, key) => (
                                <Route
                                    path={route.path}
                                    //Passing logged user and redux form methods for all components
                                    render={({ ...props }) => (
                                        <route.component
                                            {...props}
                                            user={user}
                                            resetForm={resetForm}
                                            submitForm={submitForm}
                                            notify={this.notify}
                                        />
                                    )}
                                    key={key}
                                />
                            ))
                        }
                        <Route render={() => <Redirect to="/partners" />} />
                    </Switch>
                </div>
            </div>
        )
    }

    //Notifications
    notify = (message, level) => {
        this.state._notificationSystem.addNotification({
            title: null,
            message: (<b>{message}</b>),
            level,
            position: 'tr',
            autoDismiss: 4
        })
    }
}

const mapStateToProps = state => ({ user: state.auth.user })

export default withRouter(connect(mapStateToProps, { logoff, resetForm, submitForm })(Enele))




// WEBPACK FOOTER //
// ./src/containers/Enele.jsx